export const titles = [
  {
    id: "xingji-yuanhang",
    title: "星际迷航：远航",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["科幻", "冒险"],
    rating: 8.7,
    duration: "138 分钟",
    director: "克里斯·诺兰",
    actors: ["杰克·哈里斯", "艾米莉·布朗", "大卫·陈"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20key%20art%20of%20a%20lone%20astronaut%20standing%20before%20a%20colossal%20starship%20deep%20black%20space%20background%20with%20warm%20orange%20nebula%20glow%20dramatic%20rim%20lighting%20film%20grain%20high%20detail%20professional%20poster%20composition%20with%20negative%20space%20at%20the%20top&width=400&height=600&seq=wm-cover-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20sci-fi%20banner%20of%20a%20massive%20starship%20gliding%20past%20a%20glowing%20planet%20deep%20dark%20space%20backdrop%20with%20warm%20orange%20light%20streaks%20atmospheric%20haze%20epic%20scale%20film%20still%20aesthetic%20rich%20detail%20wide%20composition%20with%20dark%20tones%20for%20text%20overlay&width=1280&height=720&seq=wm-banner-01&orientation=landscape",
    synopsis: "人类首艘远航舰队穿越虫洞，寻找可供移居的新家园。",
    plot: "公元 2185 年，地球资源濒临枯竭，人类启动了「远航计划」。舰长林远带领三百名船员，驾驶星际飞船穿越神秘虫洞，前往未知星系寻找宜居行星。旅途中，他们遭遇了时空乱流、外星文明的试探与船员之间的信任危机。当飞船抵达目标星系时，一个远比想象更宏大的真相正等待着他们。这是一部关于勇气、牺牲与希望的太空史诗。",
    views: "2.4 亿",
    viewsNum: 240000000,
    episodes: 0,
    featured: true,
    tags: ["太空", "史诗", "高概念", "视觉奇观"],
  },
  {
    id: "changan-yexing",
    title: "长安夜行",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["古装", "动作"],
    rating: 8.4,
    duration: "126 分钟",
    director: "陈墨函",
    actors: ["赵子昂", "李清欢", "王野"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20period%20action%20movie%20poster%20of%20a%20hooded%20swordsman%20on%20a%20misty%20ancient%20city%20street%20at%20night%20dark%20charcoal%20background%20with%20warm%20lantern%20orange%20glow%20dramatic%20rim%20light%20film%20grain%20high%20detail%20professional%20poster%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20an%20ancient%20Chinese%20night%20city%20with%20red%20lanterns%20and%20a%20lone%20rider%20galloping%20through%20mist%20deep%20dark%20toned%20backdrop%20with%20warm%20orange%20highlights%20atmospheric%20haze%20epic%20film%20still%20rich%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=1280&height=720&seq=wm-banner-02&orientation=landscape",
    synopsis: "一夜之内，一名游侠要在长安城中阻止一场惊天阴谋。",
    plot: "盛唐长安，上元灯会之夜。退隐多年的游侠萧夜被卷回江湖，因为他发现当年的仇家正密谋在灯火通明的城中发动一场刺杀。为了救下素不相识的无辜百姓，也为了守住心中最后的道义，萧夜在整座长安城展开一夜追凶。刀光映着灯火，人心藏在暗处，他必须在黎明之前做出抉择。",
    views: "1.9 亿",
    viewsNum: 190000000,
    episodes: 0,
    featured: true,
    tags: ["盛唐", "追凶", "夜戏", "武侠"],
  },
  {
    id: "chenmo-zhengren",
    title: "沉默证人",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "犯罪"],
    rating: 8.6,
    duration: "118 分钟",
    director: "周牧野",
    actors: ["孙皓然", "周晴", "林伟"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%20of%20a%20silhouetted%20detective%20under%20a%20single%20street%20lamp%20deep%20dark%20city%20background%20with%20warm%20orange%20and%20grey%20contrast%20dramatic%20lighting%20film%20grain%20high%20detail%20professional%20key%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-03&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20thriller%20banner%20of%20a%20rainy%20dark%20city%20alley%20with%20a%20lone%20figure%20and%20police%20lights%20deep%20dark%20toned%20scene%20with%20warm%20amber%20highlights%20atmospheric%20fog%20film%20still%20aesthetic%20rich%20detail%20wide%20composition%20with%20dark%20area%20for%20text%20overlay&width=1280&height=720&seq=wm-banner-03&orientation=landscape",
    synopsis: "一桩没有目击者的命案，唯一的证人却拒绝开口。",
    plot: "深夜的旧城区发生一起命案，现场唯一的目击者是个不会说话的孩子。刑警队长秦朗接手此案，却发现线索一次次指向自己被尘封的过去。随着调查深入，一个隐藏多年的交易浮出水面。真相近在眼前，而选择说出真话的代价，远比沉默沉重。",
    views: "1.6 亿",
    viewsNum: 160000000,
    episodes: 0,
    featured: true,
    tags: ["犯罪", "反转", "硬核", "社会派"],
  },
  {
    id: "shenhai-huixiang",
    title: "深海回响",
    type: "movie",
    year: 2023,
    region: "英国",
    genres: ["科幻", "冒险"],
    rating: 8.2,
    duration: "132 分钟",
    director: "奥利弗·格雷",
    actors: ["艾拉·沃森", "汤姆·布莱克", "娜奥米·里德"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20underwater%20sci-fi%20movie%20poster%20of%20a%20deep%20sea%20diver%20before%20a%20glowing%20ancient%20structure%20deep%20dark%20teal%20toned%20ocean%20with%20warm%20orange%20bioluminescent%20glow%20dramatic%20lighting%20film%20grain%20high%20detail%20professional%20poster%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-04&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20underwater%20banner%20of%20a%20deep%20sea%20submarine%20descending%20toward%20a%20glowing%20ruin%20deep%20dark%20ocean%20backdrop%20with%20warm%20orange%20bioluminescence%20atmospheric%20particles%20film%20still%20aesthetic%20rich%20detail%20wide%20dark%20composition%20for%20text&width=1280&height=720&seq=wm-banner-04&orientation=landscape",
    synopsis: "深潜器在万米海沟收到一段不属于人类的回声。",
    plot: "海洋学家莉娜带领团队潜入马里亚纳海沟，追踪一段神秘的声呐信号。在深海最深处，他们发现了一座超出人类认知的古老遗迹。随着下潜深度增加，通讯中断、设备失灵，团队开始怀疑他们追踪的并不是自然现象，而是一个正在回应他们的存在。",
    views: "1.3 亿",
    viewsNum: 130000000,
    episodes: 0,
    featured: false,
    tags: ["深海", "科研", "未知", "惊悚"],
  },
  {
    id: "xiari-yanhuo",
    title: "夏日烟火",
    type: "movie",
    year: 2022,
    region: "日本",
    genres: ["爱情", "剧情"],
    rating: 8.0,
    duration: "112 分钟",
    director: "山田春树",
    actors: ["佐藤美咲", "高桥健太", "小林优"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20drama%20movie%20poster%20of%20a%20young%20couple%20watching%20fireworks%20on%20a%20summer%20night%20deep%20dark%20blue%20toned%20background%20with%20warm%20orange%20firework%20glow%20soft%20dramatic%20lighting%20film%20grain%20high%20detail%20professional%20poster%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-05&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20two%20silhouettes%20on%20a%20riverside%20bridge%20beneath%20summer%20fireworks%20deep%20dark%20toned%20night%20sky%20with%20warm%20orange%20sparks%20atmospheric%20haze%20romantic%20film%20still%20rich%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=1280&height=720&seq=wm-banner-05&orientation=landscape",
    synopsis: "一个只持续七天的夏天，和一场没有说出口的告白。",
    plot: "在小镇的最后七个夏夜，转学生美咲遇见了守着老照相馆的少年健太。两人约定在烟火大会那天一起看烟花，却因为各自的家庭与未来之间摇摆。烟花开满夜空的那一刻，他们终于说出藏在心里的话，也迎来了各奔东西的夏天。",
    views: "9200 万",
    viewsNum: 92000000,
    episodes: 0,
    featured: false,
    tags: ["纯爱", "青春", "治愈", "夏日"],
  },
  {
    id: "dushi-feiche",
    title: "都市飞车",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["动作", "犯罪"],
    rating: 7.8,
    duration: "124 分钟",
    director: "马库斯·李",
    actors: ["瑞恩·福特", "卡米拉·罗斯", "德文·沃克"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%20of%20a%20muscle%20car%20drifting%20through%20a%20neon%20night%20street%20deep%20dark%20urban%20background%20with%20warm%20orange%20neon%20reflections%20motion%20blur%20dramatic%20lighting%20film%20grain%20high%20detail%20professional%20key%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-06&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20action%20banner%20of%20a%20sports%20car%20speeding%20through%20a%20dark%20city%20at%20night%20with%20orange%20neon%20light%20trails%20deep%20dark%20toned%20backdrop%20with%20warm%20highlights%20atmospheric%20haze%20film%20still%20rich%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=1280&height=720&seq=wm-banner-06&orientation=landscape",
    synopsis: "地下车手为救妹妹，被迫参与一场跨越全城的午夜竞速。",
    plot: "退役车手凯尔过着低调的生活，直到妹妹被卷入一场地下交易。为了把她救出来，他必须重返赛道，在一夜之间完成一场横穿整座城市的危险竞速。警笛、霓虹与引擎轰鸣交织，凯尔要在速度与理智之间找到唯一的出口。",
    views: "1.1 亿",
    viewsNum: 110000000,
    episodes: 0,
    featured: false,
    tags: ["竞速", "爽片", "都市", "犯罪"],
  },
  {
    id: "shannabian-de-jia",
    title: "山那边的家",
    type: "movie",
    year: 2021,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    rating: 8.3,
    duration: "108 分钟",
    director: "何安然",
    actors: ["李守田", "王小满", "张桂兰"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20movie%20poster%20of%20an%20elderly%20villager%20and%20a%20child%20before%20misty%20mountains%20at%20dusk%20deep%20dark%20toned%20rural%20background%20with%20warm%20orange%20sunset%20glow%20soft%20dramatic%20lighting%20film%20grain%20high%20detail%20professional%20poster%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-07&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20remote%20mountain%20village%20at%20golden%20dusk%20with%20terraced%20fields%20deep%20dark%20toned%20landscape%20with%20warm%20orange%20light%20atmospheric%20mist%20film%20still%20aesthetic%20rich%20detail%20wide%20composition%20with%20dark%20space%20for%20text%20overlay&width=1280&height=720&seq=wm-banner-07&orientation=landscape",
    synopsis: "一位老人用一整个秋天，等一个说会回来的孩子。",
    plot: "大山深处，老木匠守着空荡荡的老屋。孙子小满在城里上学，答应秋天回来帮忙修屋顶。老人每天到山口张望，把等待过成了日复一日的手艺。当少年终于回到山里，他发现祖父留下的，远不只是一间老屋。",
    views: "8600 万",
    viewsNum: 86000000,
    episodes: 0,
    featured: false,
    tags: ["亲情", "乡土", "治愈", "现实"],
  },
  {
    id: "miwu-zhicheng",
    title: "迷雾之城",
    type: "movie",
    year: 2023,
    region: "韩国",
    genres: ["悬疑", "惊悚"],
    rating: 8.1,
    duration: "120 分钟",
    director: "朴镇浩",
    actors: ["郑在勋", "韩瑞妍", "姜民秀"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20thriller%20movie%20poster%20of%20a%20lone%20figure%20walking%20into%20thick%20fog%20on%20a%20dark%20city%20street%20deep%20dark%20grey%20background%20with%20a%20faint%20warm%20orange%20street%20light%20dramatic%20lighting%20film%20grain%20high%20detail%20professional%20key%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-08&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20thriller%20banner%20of%20a%20foggy%20dark%20city%20skyline%20with%20a%20single%20warm%20orange%20light%20in%20the%20mist%20deep%20dark%20toned%20scene%20atmospheric%20fog%20film%20still%20aesthetic%20rich%20detail%20wide%20composition%20with%20dark%20area%20reserved%20for%20text&width=1280&height=720&seq=wm-banner-08&orientation=landscape",
    synopsis: "一场持续三十天的大雾里，有人消失了，也有人露出了真面目。",
    plot: "城市被一场罕见的大雾笼罩，交通瘫痪，通讯中断，人们被困在各自的生活里。当第一起失踪案发生，记者敏珠发现所有线索都指向同一片街区。随着雾气越来越浓，真相与幻觉的边界也越来越模糊——她必须在自己也迷失之前，找到那个藏在大雾里的答案。",
    views: "9800 万",
    viewsNum: 98000000,
    episodes: 0,
    featured: false,
    tags: ["悬疑", "氛围", "社会", "反转"],
  },
  {
    id: "kuaile-xingqiu",
    title: "快乐星球计划",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["喜剧", "科幻"],
    rating: 7.6,
    duration: "104 分钟",
    director: "郭小乐",
    actors: ["彭非凡", "苏晓晓", "马大伟"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20comedy%20sci-fi%20movie%20poster%20of%20a%20quirky%20inventor%20beside%20a%20homemade%20rocket%20in%20a%20garage%20deep%20dark%20toned%20background%20with%20warm%20orange%20work%20light%20playful%20dramatic%20lighting%20film%20grain%20high%20detail%20professional%20poster%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-09&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20comedy%20banner%20of%20a%20homemade%20rocket%20launching%20from%20a%20suburban%20backyard%20at%20night%20deep%20dark%20toned%20sky%20with%20warm%20orange%20flames%20atmospheric%20smoke%20film%20still%20aesthetic%20rich%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=1280&height=720&seq=wm-banner-09&orientation=landscape",
    synopsis: "一群普通人决定用最土的办法，造一艘最酷的飞船。",
    plot: "修车厂老板老彭无意间收到一段来自外太空的讯号，认定这是「外星朋友」的邀请。他拉上邻居、快递员和前物理老师，用废铁和土办法拼出一艘「飞船」。一路上笑料百出，意外不断，但当他们真的把火箭送上天时，小镇的每个人都抬头看见了光。",
    views: "7400 万",
    viewsNum: 74000000,
    episodes: 0,
    featured: false,
    tags: ["喜剧", "合家欢", "励志", "脑洞"],
  },
  {
    id: "jianying-jianghu",
    title: "剑影江湖",
    type: "movie",
    year: 2022,
    region: "中国香港",
    genres: ["武侠", "动作"],
    rating: 8.0,
    duration: "116 分钟",
    director: "徐正风",
    actors: ["梁子峰", "叶倾城", "郑浩然"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20wuxia%20movie%20poster%20of%20a%20martial%20artist%20with%20a%20raised%20sword%20amid%20falling%20leaves%20deep%20dark%20toned%20background%20with%20warm%20orange%20backlight%20dramatic%20silhouette%20lighting%20film%20grain%20high%20detail%20professional%20poster%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-10&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20wuxia%20banner%20of%20a%20swordsman%20leaping%20across%20a%20misty%20bamboo%20forest%20at%20dusk%20deep%20dark%20toned%20scene%20with%20warm%20orange%20light%20shafts%20atmospheric%20haze%20film%20still%20aesthetic%20rich%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=1280&height=720&seq=wm-banner-10&orientation=landscape",
    synopsis: "一柄断剑，两代恩怨，江湖从来不问对错。",
    plot: "年少成名的剑客沈墨，因一场意外失去师门。十年后他重回江湖，只为查清当年灭门之祸的真相。仇人与故人交错，恩怨与情义纠缠。当他终于站在当年的仇敌面前，才发现自己一直追寻的，其实是放下。",
    views: "1.0 亿",
    viewsNum: 100000000,
    episodes: 0,
    featured: false,
    tags: ["武侠", "复仇", "写意", "动作"],
  },
  {
    id: "shijian-lvren",
    title: "时间旅人",
    type: "movie",
    year: 2023,
    region: "美国",
    genres: ["科幻", "剧情"],
    rating: 8.5,
    duration: "130 分钟",
    director: "亚当·凯恩",
    actors: ["卢卡斯·格林", "索菲亚·班克斯", "伊森·科尔"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20time%20travel%20movie%20poster%20of%20a%20man%20standing%20before%20a%20glowing%20circular%20portal%20deep%20dark%20background%20with%20warm%20orange%20and%20amber%20light%20dramatic%20lighting%20film%20grain%20high%20detail%20professional%20key%20art%20with%20negative%20space%20at%20the%20top&width=400&height=600&seq=wm-cover-11&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20glowing%20time%20portal%20opening%20in%20a%20dark%20ruined%20landscape%20deep%20dark%20toned%20scene%20with%20warm%20orange%20energy%20swirls%20atmospheric%20particles%20film%20still%20aesthetic%20rich%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=1280&height=720&seq=wm-banner-11&orientation=landscape",
    synopsis: "他拥有回到过去的能力，却只为一件事反复穿越。",
    plot: "物理学家丹尼尔意外造出可以回到过去的装置。起初他试图改变历史中的遗憾，却发现自己每一次穿越都在悄悄改变现在。当他的爱人从记忆中一点点消失，他必须在挽回过去与守护当下之间做出最后一次选择。",
    views: "1.5 亿",
    viewsNum: 150000000,
    episodes: 0,
    featured: false,
    tags: ["时间", "科幻", "情感", "烧脑"],
  },
  {
    id: "zuihou-shouye",
    title: "最后的守夜人",
    type: "movie",
    year: 2021,
    region: "英国",
    genres: ["战争", "剧情"],
    rating: 8.2,
    duration: "122 分钟",
    director: "亨利·沃德",
    actors: ["乔治·贝尔", "艾略特·肖", "玛莎·凯恩"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20war%20drama%20movie%20poster%20of%20a%20soldier%20keeping%20watch%20on%20a%20dark%20battlefield%20at%20dawn%20deep%20dark%20toned%20background%20with%20warm%20orange%20horizon%20glow%20dramatic%20lighting%20film%20grain%20high%20detail%20professional%20poster%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-12&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20war%20banner%20of%20a%20lone%20sentry%20on%20a%20foggy%20dark%20battlefield%20at%20sunrise%20deep%20dark%20toned%20landscape%20with%20warm%20orange%20light%20atmospheric%20smoke%20film%20still%20aesthetic%20rich%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=1280&height=720&seq=wm-banner-12&orientation=landscape",
    synopsis: "战争结束前的最后一夜，一个哨兵守住了整条防线。",
    plot: "停战协议签署前的最后一个夜晚，年轻的哨兵托马斯独自守在荒凉的阵地。他必须在漫长而寒冷的黑暗里，保持清醒、守住阵地，也要守住对家乡的思念。当黎明的光落在战壕上，他终于明白，他们守护的从来不是土地，而是彼此。",
    views: "8100 万",
    viewsNum: 81000000,
    episodes: 0,
    featured: false,
    tags: ["战争", "人性", "史诗", "催泪"],
  },
  {
    id: "dushi-miju",
    title: "都市迷局",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "犯罪"],
    rating: 8.4,
    duration: "24 集",
    director: "吴启明",
    actors: ["陈牧", "许清怡", "高远"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20series%20poster%20of%20a%20detective%20before%20a%20wall%20of%20case%20files%20deep%20dark%20toned%20office%20background%20with%20warm%20orange%20desk%20lamp%20glow%20dramatic%20lighting%20film%20grain%20high%20detail%20professional%20key%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-13&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20crime%20series%20banner%20of%20a%20dark%20city%20skyline%20at%20night%20with%20lit%20office%20windows%20and%20orange%20glow%20deep%20dark%20toned%20scene%20atmospheric%20haze%20film%20still%20aesthetic%20rich%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=1280&height=720&seq=wm-banner-13&orientation=landscape",
    synopsis: "每一起看似独立的案件，都拼向同一张更大的网。",
    plot: "刑侦队长顾南川接手一系列看似毫无关联的案件：失踪、诈骗、纵火……他逐渐发现这些案件背后指向同一股隐藏在城市深处的势力。随着调查层层推进，警队内部也出现裂痕。顾南川必须在真相与代价之间，走完这条没有回头路的迷局。",
    views: "3.2 亿",
    viewsNum: 320000000,
    episodes: 24,
    featured: true,
    tags: ["刑侦", "群像", "连环", "硬核"],
  },
  {
    id: "gongting-huijuan",
    title: "宫廷绘卷",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["古装", "剧情"],
    rating: 8.3,
    duration: "40 集",
    director: "柳含烟",
    actors: ["苏婉清", "顾景舟", "叶知秋"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20palace%20drama%20poster%20of%20a%20noble%20lady%20in%20an%20ornate%20hall%20deep%20dark%20toned%20background%20with%20warm%20orange%20candle%20glow%20elegant%20dramatic%20lighting%20film%20grain%20high%20detail%20professional%20poster%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-14&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20palace%20drama%20banner%20of%20an%20ornate%20ancient%20Chinese%20hall%20lit%20by%20warm%20orange%20lanterns%20deep%20dark%20toned%20scene%20atmospheric%20haze%20film%20still%20aesthetic%20rich%20detail%20wide%20composition%20with%20dark%20space%20for%20text%20overlay&width=1280&height=720&seq=wm-banner-14&orientation=landscape",
    synopsis: "深宫之中，一幅画成了她唯一的武器。",
    plot: "画师之女苏婉清因一幅宫廷绘画入宫，本以为能凭技艺安身，却被卷入前朝后宫的权力漩涡。她以画笔为盾，以人心为局，在步步惊心的深宫里守护想要守护的人。宫墙之内，每一笔墨色都可能决定生死。",
    views: "2.8 亿",
    viewsNum: 280000000,
    episodes: 40,
    featured: true,
    tags: ["权谋", "大女主", "服化道", "群像"],
  },
  {
    id: "qingchun-lianxisheng",
    title: "青春练习生",
    type: "tv",
    year: 2024,
    region: "韩国",
    genres: ["青春", "爱情"],
    rating: 7.9,
    duration: "16 集",
    director: "金智媛",
    actors: ["李秀彬", "朴泰俊", "崔恩熙"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20youth%20romance%20series%20poster%20of%20a%20young%20trainee%20under%20a%20stage%20spotlight%20deep%20dark%20toned%20background%20with%20warm%20orange%20stage%20glow%20dramatic%20lighting%20film%20grain%20high%20detail%20professional%20key%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-15&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20dark%20concert%20stage%20with%20warm%20orange%20spotlights%20and%20a%20lone%20performer%20silhouette%20deep%20dark%20toned%20scene%20atmospheric%20haze%20film%20still%20aesthetic%20rich%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=1280&height=720&seq=wm-banner-15&orientation=landscape",
    synopsis: "舞台灯光亮起之前，是无数个无人看见的深夜。",
    plot: "练习生秀彬为了出道名额拼尽全力，却在最关键的时刻遇见了同样怀揣梦想的泰俊。两人从竞争对手到互相支撑，在高强度的训练与残酷的淘汰赛里并肩前行。当聚光灯终于照亮舞台，他们要面对的不只是掌声，还有留在身后的选择。",
    views: "1.8 亿",
    viewsNum: 180000000,
    episodes: 16,
    featured: false,
    tags: ["青春", "励志", "舞台", "心动"],
  },
  {
    id: "xibu-bianjing",
    title: "西部边境",
    type: "tv",
    year: 2022,
    region: "美国",
    genres: ["西部", "剧情"],
    rating: 8.1,
    duration: "10 集",
    director: "托马斯·韦恩",
    actors: ["科尔·哈迪", "梅根·布莱恩", "山姆·里德"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20western%20series%20poster%20of%20a%20cowboy%20on%20horseback%20before%20a%20desert%20town%20at%20dusk%20deep%20dark%20toned%20background%20with%20warm%20orange%20sunset%20light%20dramatic%20lighting%20film%20grain%20high%20detail%20professional%20poster%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-16&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20western%20banner%20of%20a%20dusty%20frontier%20town%20at%20sunset%20with%20a%20lone%20rider%20approaching%20deep%20dark%20toned%20desert%20scene%20with%20warm%20orange%20light%20atmospheric%20dust%20film%20still%20aesthetic%20rich%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=1280&height=720&seq=wm-banner-16&orientation=landscape",
    synopsis: "边境小镇的秩序，靠一个不肯拔枪的男人维持。",
    plot: "退伍骑兵哈迪来到荒凉的边境小镇，本想平静度日，却遇上横行霸道的势力与无力反抗的镇民。他收起枪，试图用谈判与规则解决问题，直到规则彻底失效。当最后的底线被踏过，他不得不重新面对自己最想逃离的过去。",
    views: "1.2 亿",
    viewsNum: 120000000,
    episodes: 10,
    featured: false,
    tags: ["西部", "硬汉", "慢热", "质感"],
  },
  {
    id: "yizhe-renxin",
    title: "医者仁心",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["医疗", "剧情"],
    rating: 8.2,
    duration: "36 集",
    director: "沈国安",
    actors: ["方致远", "林晚秋", "周子谦"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20medical%20drama%20series%20poster%20of%20a%20doctor%20in%20a%20dim%20hospital%20corridor%20deep%20dark%20toned%20background%20with%20grey%20and%20warm%20orange%20light%20contrast%20dramatic%20lighting%20film%20grain%20high%20detail%20professional%20key%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-17&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20medical%20drama%20banner%20of%20a%20dark%20hospital%20corridor%20with%20warm%20orange%20light%20from%20a%20doorway%20deep%20dark%20toned%20scene%20atmospheric%20mood%20film%20still%20aesthetic%20rich%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=1280&height=720&seq=wm-banner-17&orientation=landscape",
    synopsis: "在生死之间，他们做出的每个决定都重如千钧。",
    plot: "急诊科主任方致远带领团队日夜奔走在生死一线。面对疑难杂症、医患矛盾与制度的困境，他和年轻医生们一次次在压力下做出抉择。有人坚守，有人动摇，也有人在手术台前重新理解了「医者」二字的分量。",
    views: "2.1 亿",
    viewsNum: 210000000,
    episodes: 36,
    featured: false,
    tags: ["医疗", "职业", "现实", "群像"],
  },
  {
    id: "mofa-xueyuan",
    title: "魔法学院纪事",
    type: "tv",
    year: 2024,
    region: "英国",
    genres: ["奇幻", "冒险"],
    rating: 8.0,
    duration: "12 集",
    director: "爱德华·诺斯",
    actors: ["艾米·克莱因", "卢卡斯·怀特", "奥利维亚·格林"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20series%20poster%20of%20a%20young%20mage%20casting%20glowing%20magic%20in%20an%20old%20library%20deep%20dark%20toned%20background%20with%20warm%20orange%20and%20amber%20spell%20light%20dramatic%20lighting%20film%20grain%20high%20detail%20professional%20key%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-18&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20fantasy%20banner%20of%20a%20grand%20dark%20magical%20academy%20hall%20with%20glowing%20warm%20orange%20runes%20deep%20dark%20toned%20scene%20atmospheric%20mist%20film%20still%20aesthetic%20rich%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=1280&height=720&seq=wm-banner-18&orientation=landscape",
    synopsis: "在这所学院里，最危险的魔法往往来自人心。",
    plot: "新生艾米进入一所古老的魔法学院，却发现学院的每一面墙都藏着秘密。她与两位同伴组成小组，一边学习咒语与魔法史，一边追查一系列诡异事件。当尘封的禁忌魔法被重新唤醒，他们必须用最不擅长的合作，去对抗一个他们从未想象过的敌人。",
    views: "1.4 亿",
    viewsNum: 140000000,
    episodes: 12,
    featured: false,
    tags: ["奇幻", "学院", "冒险", "成长"],
  },
  {
    id: "dongjing-wuyu",
    title: "东京物语新篇",
    type: "tv",
    year: 2021,
    region: "日本",
    genres: ["剧情", "家庭"],
    rating: 8.1,
    duration: "20 集",
    director: "小野寺凉",
    actors: ["田中静江", "高木诚", "中村葵"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20series%20poster%20of%20an%20elderly%20couple%20on%20a%20quiet%20evening%20street%20deep%20dark%20toned%20background%20with%20warm%20orange%20lantern%20glow%20gentle%20dramatic%20lighting%20film%20grain%20high%20detail%20professional%20key%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-19&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20quiet%20Japanese%20neighborhood%20street%20at%20night%20with%20warm%20orange%20lantern%20light%20deep%20dark%20toned%20scene%20atmospheric%20mood%20film%20still%20aesthetic%20rich%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=1280&height=720&seq=wm-banner-19&orientation=landscape",
    synopsis: "一对老人进城看望儿女，却发现彼此早已疏远。",
    plot: "年迈的田中夫妇从乡下到东京看望已经成家的儿女，却发现孩子们忙于各自的生活，无暇顾及他们。短暂相聚之后，两位老人踏上了归途，也在返程的列车上重新审视了这一生的相处。平淡日常之下，是最深沉的人情冷暖。",
    views: "9600 万",
    viewsNum: 96000000,
    episodes: 20,
    featured: false,
    tags: ["家庭", "生活流", "细腻", "口碑"],
  },
  {
    id: "jiema-zhe",
    title: "解码者",
    type: "tv",
    year: 2024,
    region: "美国",
    genres: ["科技", "悬疑"],
    rating: 8.3,
    duration: "8 集",
    director: "娜塔莉·福斯特",
    actors: ["艾登·摩尔", "蕾切尔·金", "奥斯卡·佩恩"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20tech%20thriller%20series%20poster%20of%20a%20programmer%20before%20walls%20of%20glowing%20code%20deep%20dark%20toned%20background%20with%20warm%20orange%20screen%20glow%20dramatic%20lighting%20film%20grain%20high%20detail%20professional%20key%20art%20with%20negative%20space%20at%20top&width=400&height=600&seq=wm-cover-20&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20tech%20thriller%20banner%20of%20a%20dark%20server%20room%20with%20warm%20orange%20status%20lights%20glowing%20deep%20dark%20toned%20scene%20atmospheric%20haze%20film%20still%20aesthetic%20rich%20detail%20wide%20composition%20with%20dark%20space%20for%20text&width=1280&height=720&seq=wm-banner-20&orientation=landscape",
    synopsis: "一串无法破解的代码背后，藏着一个人的全部秘密。",
    plot: "天才程序员艾登受雇破解一段来历不明的加密数据，却发现解码的过程正在反向解码他自己的人生。随着真相一点点显现，他意识到自己牵涉进一场比商业竞争更危险的博弈。科技的另一面，是任何人都无法全身而退的深渊。",
    views: "1.7 亿",
    viewsNum: 170000000,
    episodes: 8,
    featured: false,
    tags: ["科技", "黑客", "悬疑", "冷峻"],
  },
];